import React from "react";
import Sidebar from "../components/Sidebar";
import { PrivacyDocumentContent } from "../components/legal/LegalDocumentContent";

const Privacy = () => (
  <div className="flex h-screen overflow-hidden bg-slate-50/50 font-inter text-blue-900">
    <Sidebar />
    <main className="flex-1 overflow-y-auto p-12">
      <div className="max-w-4xl">
        <PrivacyDocumentContent />
      </div>
    </main>
  </div>
);

export default Privacy;
